import React, {useEffect, useState} from 'react';
import {makeStyles} from '@mui/styles';
import {Card, Grid} from '@mui/material';
import {Redirect} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {SECURITY_ROLES} from '../../../constants/SECURITY_ROLES';
import TotalDocuments from './components/TotalDocuments';
import SharedUserAccountDetails from './components/SharedUserAccountDetails/SharedUserAccountDetails';
import {dashboardService} from '../../../store/services';
import LoadingSpinner from "../../../components/Spinner/loading.spinner";
import TotalVDRs from "./components/TotalVDRs/TotalVDRs";
import buildGridItem from '../../../common/buildGridItems';
import { CompanyMetrics, PendingDocuments, UsersMetrics } from '../AdminDashboard/components';

const useStyles = makeStyles(theme => ({
  root: {
  }
}));

const SharedUserDashboard = () => {
  const classes = useStyles();
  const [ metrics, setMetrics ] = useState(null);
  const user = useSelector(state => state.authentication.user);
  const dispatch = useDispatch();

  useEffect(() => {
    let isSubscribed = true;
    if (user) {
      dashboardService.getSharedUserDashboardMetrics()
        .then(
          metrics => isSubscribed ? setMetrics(metrics.data) : null
        );
    }
    return () => (isSubscribed = false);

  }, [user, dispatch]);

  return (
    <React.Fragment>
      {user && (user.role) && (user.role === SECURITY_ROLES.SHARED_USER)?
        (
          <div className={classes.root}>
            <Grid
              container
              spacing={4}
            >
              {buildGridItem(metrics, (<TotalVDRs metrics={metrics}/>), 'VDRs', {xl: 6,lg: 6,md: 6,sm: 12, xs: 12})}
              {buildGridItem(metrics, (<TotalDocuments metrics={metrics}/>), 'Documents Shared', {xl: 6,lg: 6,md: 6,sm: 12, xs: 12})}
              {buildGridItem(metrics, (<SharedUserAccountDetails metrics={metrics}/>), 'Shared User Account Details', {xl: 12,lg: 12,md: 12,sm: 12, xs: 12})}
            </Grid>
          </div>)
        :
        (<Redirect to="/login"/>)
      }
    </React.Fragment>

  );
};

export default SharedUserDashboard;
